import { ChannelSettingToggleTextarea } from './ChannelSettingToggleTextarea';

export function ChannelInstructionsSection({
  isEnabled,
  value,
  onToggle,
  onValueChange,
  isReadOnly = false,
}: {
  isEnabled: boolean;
  value: string;
  onToggle: (enabled: boolean) => void;
  onValueChange: (value: string) => void;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingToggleTextarea
      title="Custom instructions"
      description="Overwrite the team instructions for answering in this channel"
      isEnabled={isEnabled}
      value={value}
      onToggle={onToggle}
      onValueChange={onValueChange}
      placeholder="Enter custom instructions for this channel..."
      minRows={3}
      isReadOnly={isReadOnly}
    />
  );
}
